import { createRouter, createWebHistory } from "vue-router";
import Produtos from "../views/produtos.vue";

const routes = [
    {
        path: "/",
        component: () => import("@/views/home.vue"),
        meta: { title: "Inkor - Soluções em Argamassas e Rejuntes" },
    },
    {
        path: "/sobre-nos",
        component: () => import("@/views/sobre-nos.vue"),
        meta: { title: "Sobre Nós | Inkor" },
    },
    {
        path: "/produtos/:categoriaSlug",
        name: "produtos-categoria",
        component: Produtos,
        meta: { title: "Produtos | Inkor" },
    },
    {
        path: "/produtos/:categoriaSlug/:subcategoriaSlug",
        name: "produtos-subcategoria",
        component: Produtos,
        meta: { title: "Produtos | Inkor" },
    },
    {
        path: "/todos-produtos",
        name: "todos-produtos",
        component: () => import("@/views/todos-produtos.vue"),
        meta: { title: "Todos os Produtos | Inkor" },
    },
    {
        path: "/produto/:slug",
        name: "produto",
        component: () => import("@/views/produto.vue"),
        meta: { title: "Produto | Inkor" },
    },
    {
        path: "/produto/:slug/:tamanhoSlug",
        name: "produto-tamanho",
        component: () => import("@/views/produto.vue"),
        meta: { title: "Produto | Inkor" },
    },
    // {
    //     path: "/busca",
    //     name: "busca",
    //     component: () => import("@/views/busca.vue"),
    // },
    {
        path: "/blog",
        name: "blog",
        component: () => import("@/views/blog.vue"),
        meta: { title: "Blog | Inkor" },
    },
    {
        path: "/blog/artigo/:slug",
        name: "blog-post",
        component: () => import("@/views/blog-post.vue"),
        meta: { title: "Blog | Inkor" },
    },
    {
        path: "/vagas",
        name: "vagas",
        component: () => import("@/views/vagas.vue"),
        meta: { title: "Vagas e Oportunidades | Inkor" },
    },
    {
        path: "/vaga/:slug",
        name: "vaga-detalhes",
        component: () => import("@/views/vaga-detalhes.vue"),
        meta: { title: "Vaga | Inkor" },
    },
    {
        path: "/vaga/candidatar/:slug",
        name: "vaga-candidatar",
        component: () => import("@/views/vaga-form.vue"),
        meta: { title: "Candidatar-se à Vaga | Inkor" },
    },
    {
        path: "/contato",
        name: "contato",
        component: () => import("@/views/contato.vue"),
        meta: { title: "Contato | Inkor" },
    },
    {
        path: "/cadastro-rd",
        name: "cadastro-rd",
        component: () => import("@/views/rd-contato.vue"),
        meta: { title: "Cadastro de Contato | Inkor" },
    },
    {
        path: "/politica-de-privacidade",
        name: "politica-de-privacidade",
        component: () => import("@/views/politica-de-privacidade.vue"),
        meta: { title: "Política de Privacidade | Inkor" },
    },
    {
        path: "/termos-de-uso",
        name: "termos-de-uso",
        component: () => import("@/views/termos-de-uso.vue"),
        meta: { title: "Termos de Uso | Inkor" },
    },
    {
        path: "/downloads",
        name: "downloads",
        component: () => import("@/views/downloads.vue"),
        meta: { title: "Downloads | Inkor" },
    },
    {
        path: "/simulador-ambiente",
        name: "simulador-ambiente",
        component: () => import("@/views/simulador-ambiente.vue"),
        meta: { title: "Simulador de Ambiente | Inkor" },
    },
    {
        path: "/simulador-rejunte",
        name: "simulador-rejunte",
        component: () => import("@/views/simulador-rejunte.vue"),
        meta: { title: "Simulador de Rejunte | Inkor" },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/views/404.vue"),
        meta: { title: "Página Não Encontrada | Inkor" },
    },
    {
        path: "/calculadora-consumo",
        name: "calculadora-consumo",
        component: () => import("@/views/calculadora-consumo.vue"),
        meta: { title: "Calculadora de Consumo | Inkor" },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
});

// Navigation guard para atualizar o título da página
router.beforeEach((to, from, next) => {
    // Define o título da página baseado nos metadados da rota
    const defaultTitle = "Inkor";
    document.title = to.meta.title || defaultTitle;
    next();
});

export default router;
